import React, { FunctionComponent } from 'react';
import { Eyebrow, Text } from '@companion-professional/components';

interface ProfileSectionElementProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const ProfileSectionElement: FunctionComponent<ProfileSectionElementProps> = ({
  title,
  description,
  children
}) => {
  return (
    <div className="flex items-center justify-between py-4">
      <div>
        <Eyebrow tone="muted">{title}</Eyebrow>
        <Text size="sm" tone="muted">
          {description}
        </Text>
      </div>
      <div>{children}</div>
    </div>
  );
};
